<!-- 选择电子邮箱页面 -->
<template>
  <div class="sld_my_balance">
    <InvoiceMemberTitle :memberTitle="'电子邮箱'"></InvoiceMemberTitle>
    <!-- 内容 -->
    <div class="bill_content">
      <div class="addbtn">
        <el-button class="btn" @click="addOrEdit(1)">添加邮箱</el-button>
      </div>

      <div class="email_list" v-if="emailList.data.length > 0">
        <div
          class="email_item flex_row_start_center"
          v-for="(item, index) in emailList.data"
          :key="index"
        >
          <div class="email">{{ item.email }}</div>
          <div class="edit" @click="addOrEdit(0, item)">编辑</div>
          <div
            class="edit"
            @click="addOrClose(0, item)"
            style="margin-left: 10px"
          >
            删除
          </div>
        </div>
      </div>
      <div  class="flex_row_center_center">
        <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.total"
        :hide-on-single-page="true"
        :page-size="pagination.pageSize"
        v-model:currentPage="pagination.current"
        @current-change="handleCurrentChange"
      />
      </div>
    </div>

    <!-- 添加电子邮箱 -->
    <el-dialog
      :title="addEmailTitle"
      v-model="emailFlag"
      width="510px"
      lock-scroll="false"
      top="10%"
    >
      <div>
        <div class="Invoice_item flex_row_start_center">
          <div class="title">电子邮箱：</div>
          <input
            type="text"
            placeholder="请输入电子邮箱"
            v-model="inputEmail"
            class="Invoice_item_input"
          />
        </div>
        <div class="Invoice_item flex_row_start_center">
          <div class="title">是否默认：</div>
          <el-switch
            size="large"
            v-model="seitchValue"
            style="--el-switch-on-color: #255984"
          />
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button class="el_btn_close" size="small" @click="closeBtn"
            >取消</el-button
          >
          <el-button class="el_btn_sub" size="small" @click="submitBtn">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
  
<script>
import InvoiceMemberTitle from "../../../components/InvoiceMemberTitle";
import { getCurrentInstance, ref, reactive } from "vue";
import { ElMessage } from "element-plus";
export default {
  name: "Balance",
  components: {
    InvoiceMemberTitle,
  },
  setup() {
    const addEmailTitle = ref("添加电子邮箱"); //电子邮箱
    const emailFlag = ref(false); //添加电子邮箱
    const { proxy } = getCurrentInstance();
    const emailList = reactive({ data: [] });
    const seitchValue = ref(false);
    const inputEmail = ref("");
    const emailId = ref("");
    const pagination = reactive({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    //页数改变
    const handleCurrentChange = current => {
        pagination.current = current;
        getEmail();
    };
    // 获取邮箱列表
    const getEmail = () => {
      let param = {};
      param.current = pagination.current;
      param.pageSize = pagination.pageSize;
      proxy.$get("v3/member/front/memberEmail/list", param).then((res) => {
        if (res.state == 200) {
          emailList.data = res.data.list;
          pagination.total = res.data.pagination.total;
        }
      });
    };

    getEmail();
    // 添加或编辑邮箱
    const addOrEdit = (type, item) => {
      inputEmail.value = "";
      seitchValue.value = false;
      emailFlag.value = true;
      addEmailTitle.value = type == 1 ? "添加电子邮箱" : "编辑电子邮箱";
      if (item) {
        inputEmail.value = item.email;
        seitchValue.value = item.isDefault == 1 ? true : false;
        emailId.value = item.emailId
      }
    };

    // 邮箱删除
    const addOrClose = (num, item) => {
      let param = {};
      param.emailId = item.emailId;
      proxy.$post("v3/member/front/memberEmail/delete", param).then((res) => {
        if (res.state == 200) {
          ElMessage.success(res.msg);
          getEmail();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };

    const submitBtn = () => {
      let emailReg = /^([\w]+)(.[\w]+)*@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!emailReg.test(inputEmail.value))
        return ElMessage("请填写正确的邮箱格式");
      let param = {};
      param.email = inputEmail.value;
      param.isDefault = seitchValue.value == true ? 1 : 0;
      if (addEmailTitle.value == "添加电子邮箱") {
        proxy.$post("v3/member/front/memberEmail/add", param).then((res) => {
          if (res.state == 200) {
            ElMessage.success('添加成功');
            emailFlag.value = false;
            getEmail();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
      if (addEmailTitle.value == "编辑电子邮箱") {
        param.emailId = emailId.value
        proxy.$post("v3/member/front/memberEmail/edit", param).then((res) => {
          if (res.state == 200) {
            ElMessage.success('编辑成功');
            emailFlag.value = false;
            getEmail();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const closeBtn = () => {
      emailFlag.value = false;
    };
    return {
      emailFlag,
      addEmailTitle,
      emailList,
      seitchValue,
      inputEmail,
      emailId,
      addOrEdit,
      closeBtn,
      submitBtn,
      addOrClose,
      pagination,
      handleCurrentChange,
    };
  },
};
</script>
  
<style lang="scss" scoped>
@import "../../../style/member/chooseemail.scss";
</style>
<style  lang="scss">
.sld_my_balance{

    .btn-next .el-icon,
      .el-pagination .btn-prev .el-icon {
        margin: auto;
      }
}
</style>